<template>
    <div :class="$style.frameParent">
      <div :class="$style.reservationsParent">
          <b :class="$style.reservations">Reservations</b>
          <div :class="$style.addParent">
              <div :class="$style.add">
                <button :class="$style.btnAdd" @click="showReservationModal(false)">
                  Add <img :class="$style.vectorIcon" alt="" src="/static/img/plus-white.svg" />
                </button>
              </div>
          </div>
      </div>
      <div :class="$style.frameParent1">
    		<div :class="$style.flightHoursParent">
      			<b :class="$style.flightHours">Flight Hours</b>
      			<div :class="$style.scheduledGoalParent">
        				<div :class="$style.scheduledGoal">Scheduled Goal</div>
        				<div :class="$style.div">200</div>
      			</div>
      			<div :class="$style.scheduledGoalParent">
        				<div :class="$style.scheduledGoal">Scheduled Events</div>
        				<div :class="$style.div">200</div>
      			</div>
      			<div :class="$style.scheduledGoalParent">
        				<div :class="$style.scheduledGoal">Scheduled Hours</div>
        				<div :class="$style.div">435</div>
      			</div>
      			<div :class="$style.scheduledGoalParent">
        				<div :class="$style.scheduledGoal">Completed Hours</div>
        				<div :class="$style.div">435</div>
      			</div>
    		</div>
    		<div :class="$style.flightHoursParent">
      			<b :class="$style.flightHours">Simulator Hours</b>
      			<div :class="$style.scheduledGoalParent">
        				<div :class="$style.scheduledGoal">Scheduled Goal</div>
        				<div :class="$style.div">200</div>
      			</div>
      			<div :class="$style.scheduledGoalParent">
        				<div :class="$style.scheduledGoal">Scheduled Events</div>
        				<div :class="$style.div">200</div>
      			</div>
      			<div :class="$style.scheduledGoalParent">
        				<div :class="$style.scheduledGoal">Scheduled Hours</div>
        				<div :class="$style.div">435</div>
      			</div>
      			<div :class="$style.scheduledGoalParent">
        				<div :class="$style.scheduledGoal">Completed Hours</div>
        				<div :class="$style.div">435</div>
      			</div>
    		</div>
    		<div :class="$style.flightHoursParent">
      			<b :class="$style.flightHours">Ground Hours</b>
      			<div :class="$style.scheduledGoalParent">
        				<div :class="$style.scheduledGoal">Scheduled Goal</div>
        				<div :class="$style.div">200</div>
      			</div>
      			<div :class="$style.scheduledGoalParent">
        				<div :class="$style.scheduledGoal">Scheduled Events</div>
        				<div :class="$style.div">200</div>
      			</div>
      			<div :class="$style.scheduledGoalParent">
        				<div :class="$style.scheduledGoal">Scheduled Hours</div>
        				<div :class="$style.div">435</div>
      			</div>
      			<div :class="$style.scheduledGoalParent">
        				<div :class="$style.scheduledGoal">Completed Hours</div>
        				<div :class="$style.div">435</div>
      			</div>
    		</div>
    		<div :class="$style.checkridesScheduledParent">
      			<b :class="$style.scheduledGoal">Checkrides Scheduled</b>
      			<b :class="$style.b">49</b>
    		</div>
  	  </div>
      <div :class="$style.frameRow">
        <div :class="$style.tableContainer">
          <div :class="$style.tableBorderWrapper">
            <div :class="$style.tableWrapper">
                <table>
                    <thead>
                        <tr>
                        <th>Tail #</th>
                        <th>Type</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Student</th>
                        <th>CFI</th>
                        <th>Program</th>
                        <th>Training</th>
                        <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(reservation, index) in filteredReservations" :key="index">
                        <td>{{ reservation.aircraft?.tailNumber || "-" }}</td>
                        <td>{{ reservation.aircraft?.model || "-" }}</td>
                        <td>{{
                                    reservation.dateLabel.includes("-")
                                    ? reservation.dateLabel
                                        .split("-")
                                        .map((date) => new Date(date).toLocaleDateString())
                                        .join(" - ")
                                    : new Date(reservation.dateLabel).toLocaleDateString()
                                }}</td>
                        <td>{{ reservation.timeLabel }}</td>
                        <td>{{ reservation.customersLabel }}</td>
                        <td>{{ reservation.instructorLabel }}</td>
                        <td>Instrument</td>
                        <td>Checkride Prep</td>
                        <td class="text-primary">
                            <span
                                :style="{
                                cursor: useLoginStore().isAdmin ? 'pointer' : 'default',
                                }"
                                @click="handleButtonClick(reservation)"
                                >{{ reservation.eventStatus?.name }}</span
                            >
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
      <reservation-modal
        v-if="isReservationModalVisible"
        ref="reservation-modal"
        :event="selectedEvent"
        @event-created="handleEventCreated"
        @event-updated="handleEventUpdated"
        @event-deleted="handleEventDeleted"
        @close="hideReservationModal"
      ></reservation-modal>
    </div>
  </template>
  
<script>
import EventsAPIService from "../../../servicehandlers/EventsAPIService";
import { useLoginStore } from "@/stores/loginStore";
import ReservationModal from "./Schedule/ReservationModal.vue";
  
const eventsAPIService = new EventsAPIService();
export default {
  props: {},
  components: {
    ReservationModal,
  },
  data() {
    return {
      loading: false,
      selectedDate: null,
      reservations: [],
      filteredReservations: [],
      studentFilter: [],
      statusFilter: [],
      selectedEvent: null,
      isReservationModalVisible: false,
    };
  },
  async created() {},
  mounted() {
    this.getReservations();
  },
  computed: {
    statusLabel() {
      return this.reservations.map((res) => {
        return {
          eventTypeName: res.eventType.name,
          eventStatusName: res.eventStatus.name,
          buttonStyle: {
            backgroundColor: res.eventType.scheduledColor,
            color: res.eventType.textColor,
            borderColor: res.eventType.scheduledColor,
          },
          eventId: res.id,
        };
      });
    },
  },
  methods: {
    useLoginStore,
    async getReservations() {
      try {
        this.loading = true;
        this.reservations = await eventsAPIService.getAllReservations(
          this.$router,
        );

        const dateOptions = {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
        };
        const timeOptions = { hour: "numeric", minute: "2-digit" };

        for (let res of this.reservations) {
          if (res.instructorId) {
            res.instructorLabel =
              res.instructor.user.firstName +
              " " +
              res.instructor.user.lastName;
          } else {
            res.instructorLabel = "-";
          }

          let customerStr = "";
          if (res.customer1 && res.customer2) {
            customerStr =
              res.customer1.user.firstName +
              " " +
              res.customer1.user.lastName +
              ", " +
              res.customer2.user.firstName +
              " " +
              res.customer2.user.lastName;
          } else if (res.customer1) {
            customerStr =
              res.customer1.user.firstName + " " + res.customer1.user.lastName;
          } else if (res.customer2) {
            customerStr =
              res.customer2.user.firstName + " " + res.customer2.user.lastName;
          } else {
            customerStr = "-";
          }
          res.customersLabel = customerStr;

          res.startDateTime = new Date(res.startDateTime);
          res.endDateTime = new Date(res.endDateTime);
          res.dateLabel = res.startDateTime.toLocaleDateString(
            "en-US",
            dateOptions,
          );
          if (!isSameDate(res.endDateTime, res.startDateTime)) {
            res.dateLabel +=
              " - " + res.endDateTime.toLocaleDateString("en-US", dateOptions);
          }

          res.timeLabel =
            res.startDateTime.toLocaleTimeString("en-US", timeOptions) +
            " - " +
            res.endDateTime.toLocaleTimeString("en-US", timeOptions);

          if (!res.aircraftId) {
            res.aircraftLabel = "-";
          } else {
            res.aircraftLabel =
              res.aircraft.tailNumber + " " + res.aircraft.model;
          }

          res.statusLabel =
            res.eventType.name +
            '<br><button class="hilo-button" style="background-color: ' +
            res.eventType.scheduledColor +
            "; color: " +
            res.eventType.textColor +
            "; border-color: " +
            res.eventType.scheduledColor +
            '">' +
            res.eventStatus.name +
            "</button>";
        }
        this.filterReservations();

        function isSameDate(date1, date2) {
          return (
            date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate()
          );
        }
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    filterReservations() {
      const selectedDate = this.selectedDate
        ? new Date(this.selectedDate).setHours(0, 0, 0, 0)
        : null;

      this.filteredReservations = this.reservations.filter((data) => {
        const matchesStudent =
          this.studentFilter.length === 0 ||
          (data.customer1 &&
            this.studentFilter.includes(data.customer1.userId));

        const matchesStatus =
          this.statusFilter.length === 0 ||
          this.statusFilter.includes(data.eventStatus.id);

        let matchesDate = true;
        if (selectedDate) {
          const dateRange = data.dateLabel.includes("-")
            ? data.dateLabel
                .split("-")
                .map((date) => new Date(date).setHours(0, 0, 0, 0))
            : [new Date(data.dateLabel).setHours(0, 0, 0, 0)];

          matchesDate = dateRange.some(
            (date) =>
              date === selectedDate ||
              (dateRange.length > 1 &&
                selectedDate >= dateRange[0] &&
                selectedDate <= dateRange[1]),
          );
        }

        return matchesStudent && matchesStatus && matchesDate;
      });
    },
    studentList() {
      let students = [];
      let reservations;
      if (this.studentFilter.length === 0) {
        reservations = this.filteredReservations;
      } else {
        reservations = this.reservations;
      }
      for (let reservation of reservations) {
        if (reservation.customer1?.user) {
          let temp = {
            id: reservation.customer1?.userId,
            name: this.$global.getFullName(reservation.customer1?.user),
          };
          if (!students.some((item) => item.id === temp.id)) {
            students.push(temp);
          }
        }
      }
      return students;
    },
    statusList() {
      let statuses = [];
      let reservations;
      if (this.statusFilter.length === 0) {
        reservations = this.filteredReservations;
      } else {
        reservations = this.reservations;
      }
      for (let reservation of reservations) {
        let temp = {
          id: reservation.eventStatus.id,
          name: reservation.eventStatus.name,
        };
        if (!statuses.some((item) => item.id === temp.id)) {
          statuses.push(temp);
        }
      }
      return statuses;
    },
    handleEventCreated() {
      this.hideReservationModal();
      this.resetFilters();
      this.getReservations();
    },
    resetFilters() {
      this.selectedAircraft = "all";
      this.selectedInstructors = "all";
      this.selectedRooms = "all";
      this.selectedEventTypes = "all";
    },
    handleEventUpdated(updated) {
      const index = this.reservations.findIndex(
        (event) => event.id === updated.id,
      );
      if (index !== -1) {
        this.reservations.splice(index, 1, updated);
      }
      this.hideReservationModal();
      this.resetFilters();
      this.getReservations();
    },
    handleEventDeleted(deleted) {
      const index = this.reservations.findIndex(
        (event) => event.id === deleted.id,
      );
      if (index !== -1) {
        this.reservations.splice(index, 1);
      }
      this.hideReservationModal();
      this.resetFilters();
      this.getReservations();
    },
    showReservationModal(isEdit) {
      if (!isEdit) {
        this.selectedEvent = null;
      }
      this.isReservationModalVisible = true;
    },
    hideReservationModal() {
      this.isReservationModalVisible = false;
    },
    handleButtonClick(row) {
      if (useLoginStore().isAdmin) {
        this.selectedEvent = row;
        this.showReservationModal(true);
      }
    },
  },
};
</script>
  
<style module scoped>
.frameRow {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;
    gap: 40px;
    z-index: 2;
    font-size: 40px;
}
.frameParent {
    height: 100%;
    flex: 1;
    width: 100%;
    position: relative;
    background-color: #f6f6f6;
    overflow-y: auto;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 50px;
    text-align: left;
    font-size: 18px;
    color: #404040;
    font-family: Helvetica, Arial, sans-serif;
    padding: 15px 50px;
}
.frameParent1 {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 40px;
    text-align: left;
    font-size: 15px;
    color: #404040;
    font-family: Helvetica;
    margin-top: -30px;
}
.reservations {
    width: 300px;
    position: relative;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
    margin-left: 20px;
}
.add {
    position: relative;
    line-height: 25px;
}
.vectorIcon {
    width: 10px;
    position: relative;
    height: 10px;
}
.addParent {
    width: 100px;
    border-radius: 5px;
    background-color: #3c78ff;
    height: 29px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0px 10px;
    box-sizing: border-box;
    gap: 5px;
    text-align: center;
    font-size: 18px;
    color: #fff;
}
.btnAdd {
    display: contents;
    font-size: 18px;
    font-family: Helvetica, Arial, sans-serif;
    font-weight: 400;
}
.reservationsParent {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0px;
}
.flightHours {
    position: relative;
    font-size: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.scheduledGoal {
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.div {
    position: relative;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.scheduledGoalParent {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0px;
}
.flightHoursParent {
    flex: 1;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
    border-radius: 15px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px;
    gap: 13px;
}
.b {
    position: relative;
    font-size: 75px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.checkridesScheduledParent {
    align-self: stretch;
    flex: 1;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
    border-radius: 15px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 20px 20px 39px;
    gap: 0px;
    font-size: 25px;
}
.frameGroup {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 40px;
    font-size: 15px;
}
.tableContainer {
    position: relative;
    width: 100%;
    display: block;
    justify-content: flex-start; 
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
.tableWrapper {
    overflow-x: auto;
    display: block;
    width: 100%; 
    max-width: 100%; 
}
table {
    width: 100%;
    max-width: 100%;
    background-color: white;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 10px;
    border: none !important;
}
th,td {
    border: 1px solid #40404020;
    text-align: center;
    font-size: 15px;
    font-weight: 400 !important;
}
thead th {
    white-space: nowrap;     
    padding: 8px 12px;        
    background: #666;        
    color: white;            
    font-weight: bold;       
    border-bottom: 2px solid #ccc; 
}
th {
    background-color: #696969;
    color: white;
    font-weight: bold;
    border-right: #696969 1px solid;
    border-top: none;
    border-bottom: none;
    border-left: none;
}
td {
    font-size: 14px;
    border-top: none;
    border-bottom: 1px solid #40404050;
    padding: 5px 7.5px;
    text-align: center;
}
th:first-child {
    border-top-left-radius: 10px;
    border-left: none;
}
th:last-child {
    border-top-right-radius: 10px;
    border-right: none;
}
tbody tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
}
tbody tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
}
.tableBorderWrapper {
    border-radius: 10px;
    overflow: hidden;
    max-width: 100%;
}
</style>